// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    COMPANY_PAGE_LOADING() {
      return {
        isLoading: true,
        companyPage: action.companyPage
      };
    },
    COMPANY_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'most-innovative-companies',
        'categoryPage'
      );

      // Override this for Company page
      adModelData.model.adzone = 'leadership/most-innovative-companies';
      return {
        isLoading: false,
        data: action.companyPage,
        ads: adModelData
      };
    },
    COMPANY_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
